module.exports = __webpack_public_path__ + "976199dd6c4101022daf4249ec6295d0.svg";